type InputValue = Date | string | number | null | undefined;

export function formatDate(date: InputValue, newFormat?: string): string {
  if (!date) return '';

  const d = new Date(date);
  if (isNaN(d.getTime())) return '';

  const day = d.getDate().toString().padStart(2, '0');
  const monthIndex = d.getMonth();
  const year = d.getFullYear();

  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const defaultFormat = `${day} ${monthNames[monthIndex]} ${year}`;

  if (!newFormat || newFormat === 'dd MMM yyyy') {
    return defaultFormat;
  }

  // Minimal custom format support
  return newFormat
    .replace(/dd/, day)
    .replace(/MMM/, monthNames[monthIndex])
    .replace(/MM/, (monthIndex + 1).toString().padStart(2, '0'))
    .replace(/yyyy/, year.toString());
}
